import { z } from "zod";
import { partyRoleSchema, roleSchema, uuidSchema } from "./common.js";

export const healthSchema = z.object({
  status: z.enum(["ok", "degraded"]),
  version: z.string(),
  ledgerIntegrity: z.enum(["ok", "broken", "unchecked"]),
});
export type Health = z.infer<typeof healthSchema>;

/** GET /me */
export const meSchema = z.object({
  userId: uuidSchema,
  name: z.string(),
  tenantId: uuidSchema,
  tenantName: z.string(),
  partyId: uuidSchema,
  partyRole: partyRoleSchema,
  role: roleSchema,
  hasSyntheticData: z.boolean(),
});
export type Me = z.infer<typeof meSchema>;

/** GET /auth/config, unauthenticated: what the sign-in screen needs before a session exists (D-26). */
export const authConfigSchema = z.object({
  tenantName: z.string(),
  issuer: z.string().url(),
  clientId: z.string(),
  demo: z.boolean(),
  /** Redirect to the identity provider without the sign-in card (AUTH_AUTO_SIGNIN). */
  autoSignIn: z.boolean().default(false),
  /** Sibling products for the top bar (RIEA_PRO_URL, HES_URL); HES only for a token carrying the hes role. */
  links: z
    .object({ rieaPro: z.string().url().optional(), hes: z.string().url().optional() })
    .default({}),
});
export type AuthConfig = z.infer<typeof authConfigSchema>;

export const roleMappingSchema = z.object({
  directoryGroup: z.string().min(1),
  role: roleSchema,
});
export type RoleMapping = z.infer<typeof roleMappingSchema>;
